<template>
	<div class="erco-layout-template-selection">
		<div v-if="sets.length > 0"
		     class="container">
			<div v-for="set in sets"
			     class="_item"
			     :key="set.PKM_Objekt"
			     @click="handleSetClick(set)">
				<b-card class="card">
					<div slot="header"
					     class="text-muted">
					    <span :data-infotextkey="infoTextKeyForSet(set)">
							{{ fixUpperCase(set.S_de_Objekt) }}
							<erco-tooltip v-if="infoTextForSet(set)"
							              :variant="infoTextForSet(set).variant"
							              :title="infoTextForSet(set).title"
							              :text="infoTextForSet(set).text">
							</erco-tooltip>
						</span>
					</div>

					<img class="image"
					     :src="getAbsolutePathForImage(set.S_Vorschaubild_url)"
					     :alt="`Vorschaubild für ${set.S_de_Objekt}`"
					     @error="handleImageError" />
				</b-card>
			</div>
		</div>
		<div v-else class="_empty">
			Keine Sets gefunden!
		</div>
	</div>
</template>

<script>
	import url from 'url';
	import placeholderImg from '@/assets/img/placeholder-image.svg';
	import InfoText from '@/helper/infoTextHelper';
	import ErcoTooltip from '@/components/molecules/ErcoTooltip';

	export default {
		name: 'ErcoLayoutTemplateSelectionMolecule',

		props: {
			sets: {
				type: Array,
				required: true,
				default: () => ([]),
			},
		},

		methods: {
			handleSetClick(set) {
				this.$store.dispatch('createTemplateSet', set.PKM_Objekt)
				.then(() => {
					/* Da initial schon ein prepareObjectSites ausgeführt wurde,
					   muss das Zustands-Flag wieder zurückgesetzt werden, um die Vorbereitung
					   für die neu angefragten Seiten zu ermöglichen */
					this.$store.dispatch('resetSitesArePrepared');

					/* Objektdaten neu laden, um auch die neuen Seiten zu erhalten */
					this.$store.dispatch('getObjectSetupWithSites',
						/* ohne id und lang, da diese Daten von dem vorliegenden Objekt genommen werden */)
					.catch(() => { /* TODO: Use (better) logging */ });
				});
			},

			getAbsolutePathForImage(urlPath) {
				return url.resolve(process.env.IMG_SERVER, urlPath);
			},

			handleImageError(event) {
				event.target.src = placeholderImg;
			},

			fixUpperCase(text) {
				return text.split('-')
				           .map(part => `${part[0].toUpperCase()}${part.slice(1).toLowerCase()}`)
				           .join('-');
			},

			infoTextKeyForSet(set) {
				const key = (set.S_de_Objekt || set.PKM_Objekt || '').toLowerCase();
				return `layout.presets.${key}`;
			},

			infoTextForSet(set) {
				const key = this.infoTextKeyForSet(set);
				return InfoText.for(key);
			},
		},

		components: {
			ErcoTooltip,
		},
	};
</script>


<style lang="scss">

	.erco-layout-template-selection {
		padding: 2rem;

		& > .container {
			display: flex;
			flex-direction: row;
			margin-top: 2rem;
			justify-content: center;

			& > ._item {
				flex: 1;
				margin: 0 1rem;
				cursor: pointer;

				& .card {
					& .card-block {
						padding: 0;

						& > img {
							width: 100%;
						}
					}
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// TemplateSelection.vue?6845cee4